





document.addEventListener('DOMContentLoaded', function () { 
  const modal = document.getElementById('quick-view-modal'); 
  const overlay = modal.querySelector('.modal-overlay'); 
  const closeBtn = modal.querySelector('.modal-close'); 
  const qtyInput = modal.querySelector('.modal-quantity'); 
  const decBtn = modal.querySelector('.decrement'); 
  const incBtn = modal.querySelector('.increment'); 
  const addBtn = modal.querySelector('.modal-add-button'); 

  // --- Quantity Increment/Decrement --- 
  decBtn.addEventListener('click', () => { 
    let current = parseInt(qtyInput.value, 10) || 1; 
    if (current > 1) qtyInput.value = current - 1; 
  }); 

  incBtn.addEventListener('click', () => { 
    let current = parseInt(qtyInput.value, 10) || 1; 
    qtyInput.value = current + 1; 
  }); 

  // --- Event Delegation for Quick View Buttons --- 
  document.body.addEventListener('click', async function (e) { 
    const btn = e.target.closest('.quick-view-button'); 
    if (!btn) return;  // not a quick view button click 

    const handle = btn.getAttribute('data-handle'); 
    if (!handle) return; 

    const resp = await fetch(`/products/${handle}.js`); 
    if (!resp.ok) return; 
    const product = await resp.json(); 

    // Fill modal content 
    modal.querySelector('.modal-product-title').textContent = product.title; 
    modal.querySelector('.modal-product-price').textContent = `$${(product.price / 100).toFixed(2)}`; 
    modal.querySelector('.modal-product-description').innerHTML = product.description; 

    // Product image 
    const imagesContainer = modal.querySelector('.modal-product-images'); 
    imagesContainer.innerHTML = ''; 
    if (product.images.length > 0) { 
      const img = document.createElement('img'); 
      img.src = product.images[0]; 
      img.style.width = "100%"; 
      img.style.margin = "5px"; 
      imagesContainer.appendChild(img); 
    } 

    // Variants 
    if (product.variants.length > 0) { 
      addBtn.dataset.variantId = product.variants[0].id; 
    } 

    // View full details link 
    const viewFullBtn = modal.querySelector('.view-full-detail'); 
    if (viewFullBtn) { 
      viewFullBtn.setAttribute('href', `/products/${product.handle}`); 
    } 


    const subBtn = modal.querySelector('.subscribe-now-button');
if (subBtn) {
  subBtn.addEventListener('click', () => {
    window.location.href = `/products/${product.handle}#subscribe`;
  });
}

    // Show modal 
    modal.style.display = 'flex'; 
  }); 

  // --- Close Modal --- 
  closeBtn.addEventListener('click', () => modal.style.display = 'none'); 
  overlay.addEventListener('click', () => modal.style.display = 'none'); 

  // --- Add to Cart --- 
  addBtn.addEventListener('click', async () => { 
    const variantId = addBtn.dataset.variantId; 
    const qty = parseInt(qtyInput.value, 10) || 1; 

    if (!variantId) { 
      alert('No variant found for this product.'); 
      return; 
    } 

    const resp = await fetch('/cart/add.js', { 
      method: 'POST', 
      headers: { 'Content-Type': 'application/json' }, 
      body: JSON.stringify({ id: variantId, quantity: qty }) 
    }); 

    if (resp.ok) { 
      alert('Product added to cart!'); 
      modal.style.display = 'none'; 
    } else { 
      alert('Error adding to cart.'); 
    } 
  }); 
});
